import { z } from "zod";

import { intIdCodec, intIdSchema } from "@/codecs/intId";

export const coreJobIdSchema = intIdSchema.brand<"CoreJobId">();
export type CoreJobId = z.infer<typeof coreJobIdSchema>;

export const cohireJobIdSchema = z.uuid().brand<"CohireJobId">();
export type CohireJobId = z.infer<typeof cohireJobIdSchema>;

export const nimbleAtsJobIdSchema = z.union([
  cohireJobIdSchema,
  coreJobIdSchema,
]);
export type NimbleAtsJobId = z.infer<typeof nimbleAtsJobIdSchema>;

export const isCohireJobId = (jobId: NimbleAtsJobId): jobId is CohireJobId =>
  cohireJobIdSchema.safeParse(jobId).success;

export const coreJobIdCodec = intIdCodec(coreJobIdSchema);
